<template>
  <div style="position: relative;">
    <template v-if="listData && listData.length > 0">
      <ul
        class="pbr-index-table-ul"
        v-infinite-scroll="loadMore"
        :infinite-scroll-distance="20"
        :infinite-scroll-disabled="infiniteScrollDisabled"
        :style="{ height: parseInt(height) + 'px' }"
      >
        <li
          v-for="(item, index) in listData"
          :key="index"
          @click="gotoDetail(item)"
        >
          <slot></slot>
          <i class="pbr-index-dot"></i>
          <span
            class="pbr-list-span"
            v-for="(c, index) in columns"
            :key="index"
            >{{ item[c] | format(that) }}</span
          >
        </li>
        <li
          v-if="infiniteScrollDisabled && !spinShow"
          style="text-align: center;width:100%;justify-content: center;"
        >
          -No more-
        </li>
      </ul>
    </template>
    <Spin v-else-if="spinShow" class="pbr-list-loading">{{
      $t("loading")
    }}</Spin>
    <Empty v-else></Empty>
  </div>
</template>

<script>
export default {
  name: "InfiniteScrollList",
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
    canLoadMore: {
      type: Boolean,
      default: true,
    },
    height: {
      type: [Number, String],
      default: 250,
    },
    columns: {
      type: Array,
      default: function() {
        return ["title", "time"];
      },
    },
    itemClick: {
      type: Function,
    },
    url: {
      type: String,
      default: "",
    },
    method: {
      type: String,
      default: "GET",
    },
    listKey: {
      type: String,
      default: "list",
    },
    pageSize: {
      type: Number,
      default: 5,
    },
    params: {
      Type: Object,
      default: () => {
        return {
          // params: {
          from: "cn",
          pageNo: 1,
          pageSize: this.pageSize,
          // }
        };
      },
    },
    goto: {
      type: String,
    },
    rowsCountKey: {
      type: String,
      default: "total",
    },
  },
  data() {
    return {
      that: this,
      spinShow: true,
      listData: [...this.data],
      infiniteScrollDisabled: false,
    };
  },
  computed: {
    listDataByPageSize() {
      return this.listData && this.listData.length
        ? this.listData.slice(0, this.pageSize)
        : [];
    },
  },
  methods: {
    loadData() {
      let self = this;
      self.spinShow = true;
      // this.$pbrAxios.get(self.url, self.params)
      this.$pbrApis
        .requestByUrl(this.url, self.params, this.method)
        .then((res) => {
          if (!res) {
            //this.$iMessage.error({content: `${this.url} 获取列表失败`, duration: 5})
          } else if (res.code === 200) {
            console.log(self.url, res.result[self.listKey]);
            self.spinShow = false;
            self.listData = self.listData.concat(
              [],
              self.listKey ? res.result[self.listKey] : res.result
            );
            if (self.listData.length < res.result[self.rowsCountKey]) {
              self.infiniteScrollDisabled = false;
            } else {
              self.infiniteScrollDisabled = true;
            }
          } else {
            self.listData = [];
            //this.$iMessage.error({content: `${this.url} ${res.message}`, duration: 5})
          }
        })
        .catch((error) => {
          //this.$iMessage.error({content: `${this.url} ${error.message}`, duration: 5})
          self.listData = [];
        })
        .finally(() => {
          self.spinShow = false;
        });
    },
    loadMore() {
      console.log("loadMore");
      if (this.canLoadMore === false) {
        return;
      }
      if (this.params.currentpage) {
        this.params.currentpage++;
      }
      if (this.params.currentPage) {
        this.params.currentPage++;
      }
      if (this.params.pageNo) {
        this.params.pageNo++;
      }
      this.loadData();
      this.infiniteScrollDisabled = true;
    },
    gotoDetail(detail) {
      if (this.itemClick) {
        this.itemClick(detail);
      } else if (this.goto) {
        // let NewPage = '_empty' + '?t=' + new Date().getTime() / 1000 // 定义一个空页面
        // this.$router.push(NewPage)
        // this.$router.go(-1)
        this.$router.push({
          name: this.goto,
          params: detail,
          query: {
            key: detail.id,
            t: new Date().getTime() / 1000, // 时间戳，刷新当前router
          },
        });
      }
    },
  },
  watch: {
    data: {
      handler(newV, oldV) {
        if (newV.length > 0) {
          this.spinShow = false;
          this.listData = newV;
        }
      },
      immediate: true,
    },
    url: {
      handler(newV, oldV) {
        if (newV.trim().length > 0) {
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  filters: {
    format: function(value, that) {
      if (that.$moment(value).isValid()) {
        return that.$moment(value).format("yyyy-MM-DD");
      }
      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
.pbr-list-empty {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pbr-list-span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-variant-numeric: tabular-nums;
}
.pbr-index-table-ul {
  overflow-y: scroll;
}
.pbr-list-loading {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
}
</style>
